<template>
  <div>
    <!-- Selección del método de pago -->
    <div v-if="mode === 'select'" class="grid grid-cols-2 gap-4">
      <button v-for="method in payment_methods" :key="method.id" @click="selectPaymentMethod(method)"
        class="btn-blue p-4 text-lg font-medium rounded-lg hover:opacity-90 transition-opacity">
        {{ method.name }}
      </button>
    </div>

    <!-- Formulario de pago -->
    <div v-if="mode === 'form'" class="space-y-6">
      <form @submit.prevent="processPay">
        <!-- Campo monto en Bs si aplica -->
        <text-input v-if="payment_method.change_currency_id" v-model="amountAlternate" @input="lastEdited = 'bs'" type="number" step="0.01"
          class="mb-4" label="Monto en Bolívares" placeholder="Ingrese el monto en Bs" />

        <!-- Campo monto principal -->
        <text-input v-model="form.amount" :disabled="payment_method.change_currency_id" @input="lastEdited = 'usd'" type="number" step="0.01"
          class="mb-4" label="Monto en USD" placeholder="Ingrese el monto en USD" />

        <!-- Campo de tasa de cambio-->
        <text-input   v-if="payment_method.change_currency_id && change" 
        v-model="change" type="number" step="0.001" class="mb-4" label="Tasa de cambio"
          placeholder="Ingrese la tasa de cambio" />

        <!-- Campo referencia si aplica -->
        <text-input v-if="!payment_method.change" v-model="form.reference" class="mb-4" label="Referencia"
          placeholder="Ingrese el número de referencia" :error="form.errors.reference" />

        <!-- Campo voucher (comprobante de pago) -->
        <div class="mb-4">
          <label class="block text-sm font-medium mb-1">Comprobante (voucher)</label>
          <input type="file" accept="image/*" @change="onVoucherChange"
            class="form-input w-full rounded-lg border-gray-300" />
          <div v-if="voucherPreview" class="mt-2">
            <img :src="voucherPreview" alt="Voucher preview" class="h-20 rounded shadow border mx-auto" />
          </div>
        </div>

        <text-input v-model="form.date" type="date" class="mb-4" label="Fecha de pago" />

        <!-- Mostrar cambio si excede el balance -->
        <div v-if="hasChange" class="p-4 bg-blue-50 rounded-lg mb-4">
          <p class="text-md font-bold text-blue-900">
            Cambio a devolver: $ {{ changeAmount.toFixed(2) }} (Bs. {{ changeAmount.toFixed(2) * change }})
          </p>
        </div>

        <!-- Botones de acción -->
        <div class="flex items-center justify-end gap-4">
          <button type="button" @click="cancelPayment"
            class="px-6 py-2 bg-gray-800 text-white rounded-lg hover:bg-gray-900 transition-colors">
            Cancelar
          </button>
          <button type="submit" class="px-6 py-2 bg-teal-800 text-white rounded-lg hover:bg-teal-900 transition-colors">
            Procesar pago
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import TextInput from './TextInput.vue'

export default {
  props: {
    quick: {
      type: Boolean,
      default: false
    }
  },
  components: {
    TextInput
  },

  props: {
    payment_methods: {
      type: Object,
      required: true
    },
    balance: {
      type: Number,
      required: true
    },
    change: {
      type: Number,
      required: true
    },
    order: {
      type: Object,
      required: true
    },
    quick: {
      type: Boolean,
      default: false
    },
    client:{
      type: Object,
    }
  },

  data() {
    return {
      voucherPreview: null,
      mode: 'select',
      payment_method: null,
      form: this.$inertia.form({
        method: '',
        amount: 0,
        reference: '',
        quick: true,
        order_id: null,
        amount_bs: 0,
        client_id: this.client?.id || null,
        date: ''
      }),
      amountAlternate: 0,
      lastEdited: 'usd' // 'usd' o 'bs'
    }
  },

  computed: {
    hasChange() {
      return this.balance < this.form.amount
    },

    changeAmount() {
      return this.form.amount - this.balance
    }
  },

  watch: {
    amountAlternate(val) {
      if (this.payment_method && this.payment_method.change_currency_id && this.lastEdited === 'bs') {
        this.form.amount = val / this.change;
      }
    },
    'form.amount'(val) {
      if (this.payment_method && this.payment_method.change_currency_id && this.lastEdited === 'usd') {
        this.amountAlternate = val * this.change;
      }
    },
    change(val) {
      if (this.payment_method && this.payment_method.change_currency_id) {
        if (this.lastEdited === 'usd') {
          this.amountAlternate = this.form.amount * val;
        } else if (this.lastEdited === 'bs') {
          this.form.amount = this.amountAlternate / val;
        }
      }
    }
  },

  methods: {
    onVoucherChange(e) {
      const file = e.target.files[0];
      if (file) {
        this.form.voucher = file;
        this.voucherPreview = URL.createObjectURL(file);
      } else {
        this.form.voucher = null;
        this.voucherPreview = null;
      }
    },
    resetForm() {
      this.mode = 'select'
      this.payment_method = null
      this.form = this.$inertia.form({
        method: '',
        amount: 0,
        reference: '',
        quick: true,
        order_id: null,
        amount_bs: 0,
        client_id: this.client?.id || null,
        date: '' 
      })
      this.amountAlternate = 0
    },

    selectPaymentMethod(method) {
      this.mode = 'form'
      this.payment_method = method
    },

    cancelPayment() {
      this.mode = 'select'
    },

    validatePayment() {
      if (!this.payment_method.change && !this.form.reference) {
        alert('Debe ingresar una referencia')
        return false
      }

      if(this.order){
        const totalPayment = parseInt(this.form.amount) + parseInt(this.order.balance)

        if (this.order.total < totalPayment) {
          const newAmount = this.form.amount - (parseFloat(this.form.amount) - parseFloat(this.order.total))

          if (parseInt(newAmount) + parseInt(this.order.balance) > this.order.total) {
            alert('El monto del pago excede el balance pendiente')
            return false
          }

          this.form.amount = newAmount 
        }
      }

      return true
    },

    async processPay() {
      console.log(this.form)
        // Validar que si hay voucher sea imagen
        if (this.form.voucher && this.form.voucher.type && !this.form.voucher.type.startsWith('image/')) {
          alert('El comprobante debe ser una imagen válida.');
          return;
        }
        if (!this.validatePayment()) return;
        // Si es flujo público (quick y order tiene uuid)
        if (this.quick && this.order && this.order.uuid) {
          try {
            const formData = new FormData();
            formData.append('method', this.payment_method.id || this.payment_method.name);
            formData.append('amount', this.form.amount);
            formData.append('reference', this.form.reference || '');
            formData.append('date', this.form.date || '');
            if (this.form.voucher) {
              formData.append('voucher', this.form.voucher);
            }
            const resp = await fetch(`/orders/public/${this.order.uuid}/pay`, {
              method: 'POST',
              body: formData
            });
            const data = await resp.json();
            if (data.success) {
              this.$emit('success');
              this.resetForm();
            } else {
              alert('Hubo un error al registrar el pago.');
            }
          } catch (e) {
            alert('Hubo un error al registrar el pago.');
          }
          return;
        }
        // Aquí va la lógica normal
        this.form.method = this.payment_method.name
        if(this.order){
          this.form.order_id = this.order.id
        }
        this.form.amount_bs = this.amountAlternate

        if(this.order){
          this.form.post('/orders/pay')
        }else {
          this.form.post('/payments');
        }
        
        this.resetForm()
    }
  }
}
</script>